<script lang="ts" setup></script>
<template>
  <v-app-bar app>
    <v-breadcrumbs :items="[{ title: 'Translations', to: '/translations' }]" />
  </v-app-bar>
</template>
<style>
.v-toolbar {
  z-index: 100 !important;
}
</style>
